<template>
  <!-- <div class="MoblieMenuBg" @click="pageclick" ref="MoblieMenuBg">
        <div class="MoblieMenu" ref="MoblieMenu">
            <ul @click="handclick">
                <router-link to="/" tag="li">花生首页</router-link>
                <router-link to="/Tutorial" tag="li">帮助中心</router-link>
                <router-link to="/Download" tag="li">软件下载</router-link>
                <router-link to="/Buy" tag="li">套餐购买</router-link>
                <router-link v-if="!this.$store.state.LoginStatus" tag="li" class="color_one" to='/Login'><span >登录</span></router-link>
                <router-link v-if="!this.$store.state.LoginStatus" tag="li" class="color_two" to='/Register'>免费试用</router-link>
                <router-link  v-if="this.$store.state.LoginStatus" class="color_one" tag="li" to='/Personal' >个人中心</router-link>
                <li v-if="this.$store.state.LoginStatus"  @click="changeLogin" lass="color_two">退出</li>
            </ul>
        </div>
    </div> -->
  <!-- 2020-7-21新改版 -->
  <div class="MoblieMenuBg" @click="pageclick" ref="MoblieMenuBg">
    <div class="MoblieMenu" ref="MoblieMenu">
      <ul @click="handclick">
        <li>
          <a href="/anti-fraud/" target="_blank" style="color:red">反诈举报</a>
        </li>
        <li><a href="/xiazai/">软件下载</a></li>
        <li><a href="/buy/">套餐购买</a></li>
        <li><a href="/help.html">使用教程</a></li>
        <li><a href="https://ip.huashengdaili.com/">HTTP代理</a></li>
        <li><a href="/resource/#/Personal">个人中心</a></li>
        <li v-if="outBtn" @click="userout"><a>退出</a></li>
        <!-- <li><a href="/zhuce/?channel=tiaozhuan">免费注册</a></li>
                <li v-if="this.$store.state.LoginStatus"  @click="changeLogin" lass="color_two">退出</li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "MoblieMenu",
  data() {
    return {
      shwomenu: false,
      outBtn: false
    };
  },
  props: {
    show: Boolean
  },
  watch: {
    show() {
      this.shwomenu = this.show;
      this.moveMenu();
    }
  },
  methods: {
    moveMenu() {
      if (this.shwomenu) {
        this.$refs.MoblieMenu.style.left = "0rem";
      } else {
        this.$refs.MoblieMenu.style.left = "-100%";
      }
    },
    handclick() {
      this.shwomenu = !this.shwomenu;
      this.$emit("clickmenu", this.shwomenu);
    },
    pageclick() {
      if (this.shwomenu == true) {
        this.shwomenu = false;
        this.$emit("clickmenu", this.shwomenu);
      }
    },
    closemenu() {
      if (this.shwomenu && document.documentElement.scrollTop >= 5) {
        this.shwomenu = false;
        this.$emit("clickmenu", this.shwomenu);
      } else {
        return;
      }
    },
    changeLogin() {
      this.$store.commit("changeLogin", false);
      //退出时将从缓存中移除 用户session 登录状态LoginStatus
      localStorage.removeItem("session");
      localStorage.removeItem("LoginStatus");
      localStorage.removeItem("user_name");
      this.$router.push("/");
    },
    userout() {
      this.$store.commit("changeLogin", false);
      //退出时将从缓存中移除 用户session 登录状态LoginStatus 用户名存储
      localStorage.clear();
      Cookies.remove("session");
      Cookies.remove("LoginStatus");
      Cookies.remove("user_name");
      // this.$router.push("/")
      window.location.href = "/resource/login"; //2020-7-17改
    }
  },
  created() {
    this.outBtn = Boolean(
      localStorage.getItem("session") && localStorage.getItem("username")
    );
  },
  mounted() {
    window.addEventListener("scroll", this.closemenu);
    /**
     * 监听滚动条
     */
    window.onscroll = () => {
      this.shwomenu = false;
      this.$emit("clickmenu", this.shwomenu);
    };
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.moveMenu);
  }
};
// export default{
//     name: 'MoblieMenu'
// }
</script>

<style lang="stylus" scoped>
.MoblieMenu
    position fixed
    z-index 99
    background transparent
    top .96rem
    left -100%
    color #fff
    width 100%
    height 100vh
    text-align center
    transition all .3s ease-out
    // border-radius 0px 0px 8px 8px;
    ul
        width 230px!important
        height 100vh
        background #171717
.MoblieMenu ul li a
    color #686868
    display block
    width 100%
    height 100%
    text-align center
    font-size: 16px !important;
    font-weight: 600;
.MoblieMenu ul li
    height 52px
    line-height 52px
    width 100%
    cursor pointer
    &.attract
        background url('~@/assets/img/5-star-high-praise.gif') no-repeat center top
        &>a
            color transparent
.MoblieMenu ul li:hover
    background #0e2e40
</style>



// WEBPACK FOOTER //
// src/pages/Layout/components/MoblieMenu.vue